import React from "react";
import { Button, Result } from "antd";

// Evita que un error de una pantalla deje toda la app en blanco.
// `reportarError` es el punto único para conectar un servicio de monitoreo (Crashlytics, Sentry, etc.).
export const reportarError = (error, info) => {
  console.error("Error no controlado:", error, info?.componentStack);
};

class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    reportarError(error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Result
        status="error"
        title="Algo salió mal"
        subTitle="Ocurrió un problema al mostrar esta pantalla. Puedes volver al inicio o recargar la app."
        extra={[
          <Button key="inicio" type="primary" onClick={() => { window.location.href = "/"; }}>Ir al inicio</Button>,
          <Button key="recargar" onClick={() => window.location.reload()}>Recargar</Button>,
        ]}
      />
    );
  }
}

export default ErrorBoundary;
